import { AxiosResponse } from "axios";
import API from "../api";

import { SpecialInstruction } from "../models/special.instruction";

const ROUTE_NAME = "special/instructions";

const SpecialInstructionService = {
  async getAll(options?: any): Promise<AxiosResponse<SpecialInstruction[]>> {
    return await API.get(`/${ROUTE_NAME}/sales`, { params: options });
  },
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/sales/count`, { params: options });
  },
  async create(specialInstruction: SpecialInstruction): Promise<AxiosResponse<SpecialInstruction>> {
    return await API.post(`/${ROUTE_NAME}/sales`, specialInstruction);
  },
  async update(
    id: number,
    specialInstruction: SpecialInstruction
  ): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/sales/${id}`, specialInstruction);
  },
};

export default SpecialInstructionService;
